import { type FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { transform } from 'framer-motion';

import {
  H2,
  StringMain,
  StringSmall,
} from '@/components/Typography/Typography';
import { CoralButton } from '@/components/ui/Button/Button';
import { Close } from '@/components/ui/Close/Close';
import { Picture } from '@/components/ui/Picture/Picture';

import { ModalContext } from '../Modal/config';

import css from './style.module.scss';

import usdPng from '/img/icons/usd.png';
import usdLargePng from '/img/icons/usd-large.png';
import usdLargeWebp from '/img/icons/usd-large.webp';

interface props {
  price: number;
  onUsdtBuy: () => void;
}

const BuyUsdtModal: FC<props> = ({ price, onUsdtBuy }) => {
  const { t } = useTranslation();
  const { secondModal, thirdModal } = useContext(ModalContext);

  const calcElipseWidht = transform([0, 428], ['0%', '100%']);

  return (
    <div className="relative w-full  px-4 pt-5 pb-6">
      <Close
        className="absolute top-4 right-4"
        imageVariant="modal"
        variant="modal"
        onClick={() => {
          if (thirdModal.isOpen) {
            thirdModal.closeModal();
          } else {
            secondModal.closeModal();
          }
        }}
      />
      <div
        style={{
          width: calcElipseWidht(283),
        }}
        className={css.elipse}
      ></div>
      <div className="w-full h-full flex flex-col items-center isolate gap-[30px]">
        <div className="flex flex-col items-center gap-1">
          <Picture
            className="w-[7.5rem] h-[7.5rem]"
            img={usdLargePng}
            webp={usdLargeWebp}
            alt="wallet"
          />
          <H2 weight="bold" className="!text-[24px]">
            {price} USD
          </H2>
          <StringSmall className="!text-white/40">
            {t('Payment amount')}
          </StringSmall>
        </div>
        <div className="flex flex-col items-center gap-2">
          <H2>{t('Confirmation of purchase')}</H2>
          <StringSmall className="max-w-[300px] text-center !text-white/60 !leading-[120%]">
            {t('Are you sure you want to make a purchase with a balance of')}{' '}
            {price} USD?
          </StringSmall>
        </div>
        <CoralButton onClick={onUsdtBuy}>
          <StringMain
            weight="extrabold"
            className="!text-white/80 flex items-center gap-1"
          >
            <span>{t('Confirm & pay')}</span>
            <img src={usdPng} width={24} alt="" />
            <span>{price}</span>
          </StringMain>
        </CoralButton>
      </div>
    </div>
  );
};

export { BuyUsdtModal };
